<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title class="headline">Добавление Модуля ПО</v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field label="Название ПО"
                          v-model="module.name"
                          :rules="[notEmptyRule, length50]"
                          counter="50"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea label="Доп. инфо"
                        :rows="1"
                        v-model="module.description"
                        :rules="[notEmptyRule]"
                        hint="Описание"
                        persistent-hint
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <div class="text-subtitle-2 mb-2">Фичи ПО</div>

            <div class="features-block">
              <v-simple-table dense v-if="module.features.length">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Название фичи</th>
                      <th class="text-center" style="width: 140px;">По умолчанию</th>
                      <th style="width: 48px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(feature, index) in module.features" :key="index">
                      <td>{{ feature.name }}</td>
                      <td class="text-center">
                        <div class="d-flex justify-center">
                          <v-simple-checkbox v-model="feature.defaultEnabled" :ripple="false"></v-simple-checkbox>
                        </div>
                      </td>
                      <td class="text-center">
                        <v-btn icon x-small @click="removeFeature(index)">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-sheet outlined rounded class="add-feature-panel pa-3 mt-3">
                <div class="text-caption font-weight-medium mb-2">Добавить фичу</div>
                <div class="d-flex align-center" style="gap: 12px;">
                  <v-text-field
                      label="Название фичи"
                      v-model="featureDraft.name"
                      :maxlength="50"
                      dense
                      hide-details
                      background-color="white"
                      class="flex-grow-1"
                      style="min-width: 180px;"
                      @keydown.enter.prevent="addFeature"
                  ></v-text-field>
                  <v-checkbox
                      v-model="featureDraft.defaultEnabled"
                      label="По умолчанию"
                      dense
                      hide-details
                      class="mt-0 pt-0 flex-shrink-0"
                  ></v-checkbox>
                  <v-btn color="primary darken-1" text
                         class="flex-shrink-0"
                         @click="addFeature"
                         :disabled="!featureDraft.name.trim()"
                  >Добавить
                  </v-btn>
                </div>
              </v-sheet>
            </div>
          </v-col>

          <v-col cols="12">
            <v-switch
                v-model="module.isPrivate"
                label="Модуль для служебного пользования"
                class="mt-0"
            ></v-switch>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="createModule"
             :disabled="!isValid">Добавить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  name: 'ModuleCreate',
  data() {
    return {
      module: {
        features: [],
        isPrivate: false,
      },
      featureDraft: {
        name: '',
        defaultEnabled: false,
      },
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      length50: v => (v && v.length <= 50) || 'Максимум 50 символов',
    }
  },
  methods: {
    addFeature() {
      const name = (this.featureDraft.name || '').trim();
      if (!name) return;
      this.module.features.push({
        name,
        defaultEnabled: this.featureDraft.defaultEnabled,
      });
      this.featureDraft = {name: '', defaultEnabled: false};
    },
    removeFeature(index) {
      this.module.features.splice(index, 1);
    },
    createModule() {
      setTimeout(() => API.post('modules/create', this.module)
          .then((response) => {
            console.log(response.data);
            this.$store.commit('showSnackbar', {
              color: 'success',
              text: 'Модуль ПО добавлен',
            })
            // this.$refs.form.reset();
            this.$store.dispatch('updateModules');
            this.$router.push('/modules');
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Модуль ПО не добавлен',
            })
          }), 100)
    },
  },
  created() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'modules', disabled: false, to: '/modules', exact: true},
      {text: 'add', disabled: true},
    ])
  },
}
</script>

<style>
.new-chips .v-chip {
  background-color: #b6d4e7 !important;
}

.features-block {
  max-width: 680px;
}

.add-feature-panel {
  background-color: #f3f6f3;
}
</style>
